// Import our custom CSS
import '../scss/styles.scss'

// Import only the Bootstrap components we need
import { Popover, Offcanvas, Tooltip } from 'bootstrap';

// Create an example popover
document.querySelectorAll('[data-bs-toggle="popover"]')
  .forEach(popover => {
    new Popover(popover)
  })

document.querySelectorAll('[data-bs-toggle="tooltip"]')
  .forEach(tooltip => {
    new Tooltip(tooltip);
  });

document.addEventListener('DOMContentLoaded', () => {
  const btnSwitch = document.getElementById('btnSwitch');
  const lightModeIcon = document.getElementById('lightModeIcon');
  const darkModeIcon = document.getElementById('darkModeIcon');
  
  const getStoredTheme = () => localStorage.getItem('theme');
  const setStoredTheme = theme => localStorage.setItem('theme', theme);
  
  const setTheme = theme => {
    if (theme === 'auto') {
      theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    document.documentElement.setAttribute('data-bs-theme', theme);
  
    if (theme === 'light') {
      lightModeIcon.style.display = 'block';
      darkModeIcon.style.display = 'none';
    } else {
      lightModeIcon.style.display = 'none';
      darkModeIcon.style.display = 'block';
    }
  };
  
  // Initialize theme on page load
  const storedTheme = getStoredTheme();
  const preferredTheme = storedTheme || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  setTheme(preferredTheme);
  
  // Toggle theme on button click
  btnSwitch.addEventListener('click', () => {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme');
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
  
    setStoredTheme(newTheme);
    setTheme(newTheme);
  });
});